import { render } from "./currency-dropdown.vue?vue&type=template&id=c5ffd2ca"
import script from "./currency-dropdown.vue?vue&type=script&lang=js"
export * from "./currency-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__